import React, {Component} from "react";

import ChartistGraph from 'react-chartist';

import NotificationMenu from "./notification-menu.js";

import {getPointSummary} from "../../../modules/point.js";

import { setAuthToken} from "../../../modules/user.js";

require("./gamification-menu.css");
export default class GamificationMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            level: -1,
            points: -1,
            next_level_threshold: -1,
            got_level_summary: false,
            show_dropdown_menu: false,
            show_notifications_menu: false
        };
    }
    


    animateChart(data) {
        if(data.type === 'slice') {
            data.element.animate({
            opacity: {
                dur: 1000,
                from: 0,
                to: 1
            }
            });
        }
    }

    async componentDidMount() {
        let {token} = this.props;
        let pointSummaryResponse = await getPointSummary(token);

        let pointSummary = pointSummaryResponse.data;
        if (pointSummary) {
            this.setState({
                got_level_summary: true,
                points: pointSummary.points,
                next_level_threshold: pointSummary.level_threshold,
                level: pointSummary.current_level
            })
        } 
    }


    showNotificationsMenu() {
        this.setState({show_notifications_menu: true, show_dropdown_menu: false});
    }

    hideNotificationsMenu() {
        this.setState({show_notifications_menu: false});
    }

    hideDropdownMenu() {
        this.setState({show_dropdown_menu: false});
    }

    showDropdownMenu() {
        this.setState({show_dropdown_menu: true, show_notifications_menu: false});
    }

    toggleDropdownMenu() {
        let {show_dropdown_menu} = this.state;

        this.setState({show_dropdown_menu: !show_dropdown_menu});
    }

    printLevelChart() {
        let {next_level_threshold, points, level} = this.state;

        let levelProgress = Math.round((points / next_level_threshold) * 100) / 100;

        let progress = levelProgress * 360;
        
        let progressLeft = 360 - progress;

        let data = {series: [{value: progressLeft, className: "points_to_next_level"}, {value: progress, className: "points_in_level"}]};
        var options = {
            donut: true,
            donutWidth: 10,
            total: 360,
            showLabel: false,
            animation: {
                opacity: {
                    dur: 1000,
                    from: 0,
                    to: 1
                  }
            }
          };
          const type = 'Pie';



          return  (
              <span id='level_graph_container'>
                  <div id='level_graph_text_container'>
                      <div id='level_graph_text_title'>Level</div>
                      <div id='level_graph_text'>{level}</div>
                  </div>
                  <ChartistGraph className='level_chart' data={data} options={options} type={type} listener={{"draw": this.animateChart.bind(this)}}/>
              </span>
          )
          
    }


    logout() {
        setAuthToken("");
        window.location = window.location.origin;//this.props.history.replace("");
    }

    render() {
        let {user, profile_route, token} = this.props;
        let {points, next_level_threshold, got_level_summary, show_dropdown_menu, show_notifications_menu} = this.state;


        return (
            <div id='gamification_menu_container'>
                {!got_level_summary &&
                    <div></div>
                }

                <NotificationMenu token={token} show_notifications_menu={show_notifications_menu} hide_func={this.hideNotificationsMenu.bind(this)} show_func={this.showNotificationsMenu.bind(this)}></NotificationMenu>

                {got_level_summary && 
                    <div className='show_dropdown_menu_button' onMouseEnter={this.showDropdownMenu.bind(this)}>{user.currentUserFirstName}</div>
                }

                {got_level_summary && show_dropdown_menu &&
                    <div className="gamification_dropdown_menu" onMouseLeave={this.hideDropdownMenu.bind(this)}>
                        <div>
                            {this.printLevelChart()}
                            <span id='gamification_dropdown_menu_full_name_section'>
                                <div id='gamification_dropdown_menu_full_name'>{`${user.currentUserFirstName} ${user.currentUserLastName}`}</div>
                                <div id='gamification_dropdown_menu_profile_button' onClick={() => {
                                        window.location = process.env.REACT_APP_URL_PATH + profile_route;
                                    }}>See your profile</div>
                            </span>
                        </div>
                        {/* <div className='gamification_dropdown_menu_item'><span className="gamification_dropdown_menu_item_label">level:</span> <span className="gamification_dropdown_menu_item_value">{level}</span></div> */}
                        <div className='gamification_dropdown_menu_item'><span className="gamification_dropdown_menu_item_label">points:</span> <span className="gamification_dropdown_menu_item_value">{points}</span></div>
                        <div className='gamification_dropdown_menu_item'><span className="gamification_dropdown_menu_item_label">Points for next level:</span> <span className="gamification_dropdown_menu_item_value">{next_level_threshold - points}</span></div>
                        <div id='gamification_menu_logout_button' onClick={this.logout.bind(this)}>Logout</div>
                    </div>

                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/containers/gamification-menu/gamification-menu.js